import React from 'react';
import { Badge, Table, Typography } from 'antd';
import { userAllAuthDashBoardLeadStats } from 'pages/store';

const { Text } = Typography;



const LeadActionReport = ({allAuthDashBoardLeadStats, isLoading}) => {
  const agents = [...new Set([...Object.keys(allAuthDashBoardLeadStats)])].map(agent => ({
    text: agent,
    value: agent,
  }));
  
  const columns = [
    {
      title: 'Agent',
      dataIndex: 'agent',
      key: 'agent',
      width: 192,
      render: (agent, { rep_level }) => (
        <div className="flex items-center gap-1">
          <Text strong>{agent || 'NA'}</Text>
          <Badge count={rep_level} style={{ backgroundColor: '#dcfce7', color: '#166534' }} />
        </div>
      ),
      filters: agents,
      filterMode: 'tree',
      filterSearch: true,
      onFilter: (value, record) => record?.agent ? record?.agent === value : !record?.agent,
    },
    {
      title: 'Total Calls',
      dataIndex: 'total_calls',
      key: 'total_calls',
    },
    {
      title: 'Total Attempts',
      dataIndex: 'total_attempts',
      key: 'total_attempts',
    },
    {
      title: 'Not Attempted',
      dataIndex: 'not_attempted',
      key: 'not_attempted',
    },
    {
      title: 'Answered',
      dataIndex: 'answered',
      key: 'answered',
    },
    {
      title: 'Unanswered',
      dataIndex: 'unanswered',
      key: 'unanswered',
    }
  ];
  const coldCallDataSource = Object.entries(allAuthDashBoardLeadStats).map(([agent, stats], index) => ({ key: index, agent, ...stats }));
  return (
    
  <div className="mt-1">
    <Table
      columns={columns}
      dataSource={coldCallDataSource}
      pagination={false}
      loading={isLoading}
      summary={pageData => {
        const summary = pageData.reduce((acc, record) => {
          Object.keys(record).forEach(key => {
            if (key !== 'agent' && key !== 'key') {
              acc[key] = (acc[key] || 0) + record[key];
            }
          });
          return acc;
        }, {});

        return (
        
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell><Text strong>Total</Text></Table.Summary.Cell>
              {columns.slice(1).map(col => (
                <Table.Summary.Cell key={col.key}>
                  <Text strong>{summary[col.dataIndex]}</Text>
                </Table.Summary.Cell>
              ))}
            </Table.Summary.Row>
          </Table.Summary>
        );
      }}
    />
  </div>
  )
};

export default LeadActionReport;
